export enum TestLevelEnum {
  NotSet = '',
  Higher = 'higher',
  Foundation = 'foundation',
}
